export default __webpack_public_path__ + "static/media/presentation-4.066f4eaf.png";